import React from "react";
import { DYNAMIC_ISLAND } from "../../../config/dynamicIsland.configuration";
import { getUIColorPalette } from "../../../theme/ColorPalette";

interface DynamicIslandBackgroundShellProps {

    /** Whether dark UI palette is active. */
    "isDarkUi": boolean;

    /** Variant content (optionally wrapped by other shell layers). */
    "children": React.ReactNode;
}

/**
 * Generic overlay background shell for Dynamic Island variants.
 * Uses {@link getUIColorPalette} `dynamicIslandBackground` with FAB-aligned `shadow-xl`.
 *
 * @param props Component props.
 * @returns Blurred card wrapper at island height.
 */
const DynamicIslandBackgroundShell: React.FC<DynamicIslandBackgroundShellProps> = ( {
    isDarkUi,
    children,
} ) => {
    const palette = getUIColorPalette( isDarkUi );

    return (
        <div
            className="pointer-events-auto w-full min-w-0 overflow-hidden rounded-2xl border-0 px-1 py-0 shadow-xl backdrop-blur-sm"
            style={{
                "backgroundColor": palette.dynamicIslandBackground,
                "height":          `${ DYNAMIC_ISLAND.heightPx }px`,
            }}
        >
            {children}
        </div>
    );
};

export default DynamicIslandBackgroundShell;
